<template>
	<div class="container">
		<!--页面开始-->
		<div class="set_box">
			<div class="set_top">
				<div class="set_tit">请输入验证码</div>
			</div>
			<van-form>
				<!--手机号-->
				<van-field
					v-model="form.phone"
					name="手机号"
					label="手机号"
					type="tel"
					placeholder="请输入手机号"
					maxlength="11"
				/>
				<!--手机号-->
				<!--验证码-->
				<van-field
					v-model="form.code"
					center
					clearable
					type="tel"
					label="验证码"
					placeholder="请输入验证码"
					maxlength="4"
				>
				  <template #button>
					<van-button
						class="send_box"
						size="small"
						type="primary"
						color="#f9f1ff"
						:disabled="isDisabled"
						@click="sendCode"
					>
						{{ sendMsg }}
					</van-button>
				  </template>
				</van-field>
				<!--验证码-->
				<div class="btn_box">
					<van-button
						type="info"
						plain
						block
						@click="onSubmit"
						color="#4f56fe"
					>
						<span style="font-size: 0.5rem;">设置密码</span>
					</van-button>
				</div>
			</van-form>
		</div>
		<!--页面开始-->
	</div>
</template>

<script>
import md5 from 'js-md5';
import { sendSms, verity } from "@/api/login/index";
import { shareUrl } from '@/utils/wxshare'

export default {
	components:{
		//
	},
	data() {
		return {
			form: {
				phone: '',
				code: '',
			},
			isDisabled: false,
			sendMsg: '发送验证码',
			countDown: null,  //定时器
		}
	},
	created(){
		//
	},
	mounted() {
		//微信分享
		let that = this;
		that.$nextTick(() => {
			shareUrl(that);
		});
	},
	watch: {
		//
	},
	methods: {
		//发送验证码
		sendCode() {
			let that = this;
			if(that.form.phone != "") {
				if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.form.phone))){ that.$toast("请输入正确的手机号码"); return false; } 
				let time = String(moment(new Date()).valueOf());
				let str = md5(that.form.phone + 'baoyitong2022');
				let str2 = sha512(md5(that.form.phone.slice(0, 3) + time +that.form.phone.slice(-4) + 'baoyitong2022'));
				//发送验证码
				that.isDisabled = true;
				sendSms({phone: that.form.phone, sign: str, timer: time, ticket: str2}).then(res => {
					let countNum = 60;
					that.countDown = setInterval(() => {
						countNum--;
						that.sendMsg = '重新获取' + countNum + ' s';
						if(countNum <= 0) {
							clearInterval(that.countDown);
							that.isDisabled = false;
							that.sendMsg = '发送验证码';
						}
					}, 1000);
				});
			}else {
				that.$toast('请输入手机号码');
			}
		},
		//点击登录
		onSubmit() {
			let that = this;
			if(that.form.phone == "") {that.$toast('请输入手机号码');return false;}
			if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.form.phone))){ that.$toast("请输入正确的手机号码"); return false; }
			if(that.form.code == "") {that.$toast('请输入验证码');return false;}
			//验证身份
			verity({phone: that.form.phone, code: that.form.code}).then(res => {
				sessionStorage.setItem('token', res.token);
				sessionStorage.setItem('userPhone', that.form.phone);
				if(that.$route.query.type && that.$route.query.invite) {
					that.$router.push({path:'/forgetpwdtwo', query: {type: that.$route.query.type, invite: that.$route.query.invite}});
				}else {
					that.$router.push({path:'/forgetpwdtwo'});
				}
			});
		},
	},
	beforeDestroy() {
		clearInterval(this.countDown);
	}
}
</script>
</script>

<style scoped>
.set_box{
	width: 100%;
	height: 100vh;
	background-color: #F7F7F9;
}
.set_top{
	margin-bottom: 0.5rem;
	padding: 0.8rem 0 0.5rem 0.4rem;
	background-color: #ffffff;
}
.set_top .set_tit{
	font-size: 0.6rem;
	color: #333333;
}
.set_top .set_txt{
	font-size: 0.32rem;
	color: #333333;
}

>>> .send_box .van-button__text{
	color: #bf85ff;
}

>>> .van-cell{
	line-height: 0.8rem;
}
>>> .van-field__label{
	width: 1.8rem;
}

.btn_box{
	padding: 0.5rem 1.5rem 0.4rem 1.5rem;
}
.btn_box .van-button{
	height: 1.4rem !important;
	background-color: transparent;
}
.bot_bot{
	position: fixed;
	width: 100%;
	text-align: center;
	left: 0;
	bottom: 0.4rem;
}
.bot_bot  div{
	font-size: 0.38rem;
	color: #666666;
}

.btn_tit{
	text-align: center;
	font-size: 0.38rem;
	color: #999999;
	opacity: 0.5;
}

>>> .van-button--primary{
	border: none;
	background: transparent !important;
}
.send_box .van-button__text{
	color: #4F56FE !important;
}
>>> .van-button--disabled .van-button__text{
	color: #999999 !important;
}

>>> .van-button--small{
	height: 32px !important;
}
</style>
